import { cn } from "@/lib/utils"
import { ResultCard } from "@/components/ui/result-card"
import { clientVoices } from "./content"
import { toneBg, type SectionTone } from "./section-tone"
import novaLogo from "@/assets/client-logos/nova.png"
import warmHomesLogo from "@/assets/client-logos/warm-homes.png"
import solarheroLogo from "@/assets/client-logos/solarhero.png"
import chrisOrrPhoto from "@/assets/testimonials/chris-orr.jpg"
import seanDalyPhoto from "@/assets/testimonials/sean-daly.jpg"
import yousafBilalPhoto from "@/assets/testimonials/yousaf-bilal.jpg"

// Logo + headshot for each client voice, keyed by the `client` string in
// content.ts. Self-contained to this section (the results wall keeps its own
// logo map for the numbers-only cards).
const LOGOS: Record<string, string> = {
  "NOVA": novaLogo,
  "Warm Homes": warmHomesLogo,
  "SolarHero": solarheroLogo,
}
const HEADSHOTS: Record<string, string> = {
  "NOVA": chrisOrrPhoto,
  "Warm Homes": seanDalyPhoto,
  "SolarHero": yousafBilalPhoto,
}

// Testimonials section, directly under the hero: three UK client voices as
// hybrid cards (a metric badge AND the client's own quote + headshot). Sits on
// the surface tone so it reads as a distinct proof band under the page-toned
// hero. The numbers-only cards live in the Results section further down.
export function Testimonials({ tone = "surface" }: { tone?: SectionTone }) {
  return (
    <section
      id="testimonials"
      data-section="testimonials"
      className={cn("scroll-mt-24 border-b border-hairline", toneBg[tone])}
    >
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
        <span className="section-eyebrow">Testimonials</span>
        <h2 className="section-title mt-3 max-w-2xl">In their words.</h2>

        <ul className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {clientVoices.map((voice) => (
            <li key={voice.client}>
              <ResultCard
                client={voice.client}
                context={voice.context}
                tag={voice.tag}
                figure={voice.figure}
                figureLabel={voice.figureLabel}
                logo={LOGOS[voice.client]}
                quote={voice.quote}
                quoteName={voice.quoteName}
                quoteRole={voice.quoteRole}
                quoteImage={HEADSHOTS[voice.client]}
                className="h-full"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
